<template>
  <div class="content">
	 
    <div class="row">
      <div class="col-12">
        <card>
          <template slot="header">
            <h4 class="card-title">我的订单</h4>
          </template>
          <div class="search">			  
			  <input type="text" class="form-control col-2" placeholder="合同编码" aria-label="合同编码" aria-describedby="basic-addon1"  v-model="searchParams.contractNo">
			  <input type="text" class="form-control col-2" placeholder="物料编码" aria-label="物料编码" aria-describedby="basic-addon1"  v-model="searchParams.materialNo">
			  <button type="button" class="btn btn-primary" @click="searchParams.pageNum=1;search()">查找</button>
		  </div>
          <div class="table-responsive text-left">
			  <table  class="table">
			      <thead>
			        <tr>
					  <th>公司名称</th>
					  <th>创建时间</th>
					  <th>合同编码</th>
					  <th>物料编码</th>
					  <th>型号</th>
					  <th>数量</th>
					  <th>货期</th>
					  <th>状态</th>
			        </tr>
			      </thead>
			      <tbody>
			        <tr v-for="(item,key) in orders" :key="item.id">
					    <td >{{ item.companyName}}</td>
					   <td >{{ item.dateEntered}}</td>
					   <td >{{ item.contractNo }}</td>
					   <td >{{ item.materialNo }}</td>	
						<td >{{ item.model }}</td>
						<td >{{ item.number }}</td>
						<td >{{ item.delivery }}</td>	
						<td ><a href="#" @click="status(item.ydnNo)">查看</a></td>
					</tr>
			      </tbody>
			    </table>
          </div>
		  
		  <nav aria-label="Page navigation example" style="margin-top:30px;">
		    <ul class="pagination justify-content-center">
		      <li class="page-item" id="previous" :class="{'disabled':searchParams.pageNum==1}">
		        <a class="page-link" href="#" @click="previous()">Previous</a>
		      </li>
			  <li class='page-item' style="margin-left: 5px;margin-right: 5px;"> page {{searchParams.pageNum}} of {{pages}} </li>			  
		      <li class="page-item" id="next" :class="{'disabled':searchParams.pageNum==pages}">
		        <a class="page-link" href="#" @click="next()">Next</a>
		      </li>	
			  <li class="pageSize" style="margin-left: 5px;"> 每页：<span><a href="#" @click="searchParams.pageSize=10;searchParams.pageNum=1;search();">10</a></span><span><a href="#" @click="searchParams.pageSize=50;searchParams.pageNum=1;search();">50</a></span><span><a href="#"  @click="searchParams.pageSize=100;searchParams.pageNum=1;search();">100</a></span></li>
			</ul>
		  </nav>	  
        </card>
      </div>
    </div>

    <Modal :isVisible="showModal" @close="showModal = false">
		<template #header>
		    <div style="color:#000">
			订单进度：({{orderId}})
			</div>
		</template>		
		<div class="row">
			<div v-show="wait" style="width:100%;"><img src="./../assets/img/loading.gif" style="margin: auto;width:150px;"/></div>
			<div v-show="lc">
			<ul style="width:100%;text-align: left;">
				<li>物料准备：
				<table class="table-hover" style="width:100%;">
					<thead>					
					<tr>
						<th>序号</th><th>零件名称</th><th>生产</th><th>配料</th>
					</tr>
					</thead>
					<tbody>
				    <tr v-for="(item,index) in proName" :key="index">
						<td>{{index+1}}</td>
						<td>{{item.componentName}}</td>
						<td>
							<span v-for="(item2,index) in item.produce" :key="index">
							<i class="bi-check-circle" v-if="item2.state=='W'" style="color: green;"></i>{{item2.currGx}}
						</span>
                        </td>
						<td><i class="bi-check-circle" v-if="item.status==true" style="color:green;"></i></td>
					</tr>
					</tbody>				
				</table>
				</li>
				<li>装配：{{orderState}}</li>
			</ul>
			</div>
		</div>		
		
		<template #footer>
         <div></div>
		</template>		
    </Modal>	

  </div>
</template>

<script>

import { Card } from "@/components/index";
import Modal from "@/pages/Layout/Modal.vue";
import { Message } from "element-ui";

export default {
  components: {
    Card,Modal
  },
  data() {
    return {
	  searchParams:{
	  	contractNo:"",
	  	materialNo:"",
		pageSize:10,
		pageNum:1, 
	  },
	  orders:[],
	  orderState:"",
	  pages:1,
	  pageNav:"",
	  showModal:false,
	  proName:[],
	  orderId:"",
	  wait:true,
	  lc:false,
    };
  },
  created() {
	  this.searchParams.pageNum=1;
	  this.search();
  },
  methods: {
  	async search() {
  		let res =await this.$axios.post(this.$serverUrl+"/order/search",this.searchParams);	
		this.orders=res.data.data.list;
		this.pages=res.data.data.pages;
  	},
	previous(){
		this.searchParams.pageNum=this.searchParams.pageNum-1;
		this.search();
	},
	next(){
		this.searchParams.pageNum=this.searchParams.pageNum+1;
		this.search();
	},
	async status(orderNo){
		var url=this.$url+"/#/lc?id="+encodeURIComponent(orderNo);
		window.open(url);		
	}
  },
};
</script>
<style>
	.search input{
		display:inline;
		margin-right:5px;
	}
	.page-link{
		color: #000;
	}
	.pageSize a{
	    margin-left: 10px;	
	}
</style>